import { useRooms } from '../../queries';
import { RoomsTable } from '../RoomsTable';
import { AreaGate } from './AreaGate';

/**
 * Rooms and the people who run them.
 *
 * <p>
 * Operators are no longer a panel beside the table — they are inside each room's own dialog, which
 * is the same argument one step further: an assignment is a fact about a room, so it belongs where
 * the room is rather than under a picker asking which room you meant.
 * </p>
 */
export function RoomsArea() {
  const rooms = useRooms();

  return (
    <AreaGate
      queries={[rooms]}
      loadingLabel="Loading rooms…"
      errorMessage="Couldn't load the rooms."
    >
      <RoomsTable rooms={rooms.data ?? []} />
    </AreaGate>
  );
}
